<!-- echartscom.vue -->
<template>
  <div class="chart-view">
    <div :id="echarts" class="box" ref="echarts"></div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'Pie',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    color: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    echarts() {
      return 'echarts-' + Math.random() * 100000
    }
  },
  mounted() {
    this.drawCharts()
  },
  methods: {
    drawCharts() {
      var myChart = echarts.init(document.getElementById(this.echarts))
      myChart.setOption({
        title: {
          text: '专家学历比例图',
          subtext: '纯属虚构',
          left: 'left'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: '70%',
          data: ['土木工程', '计算机', '电子商务']
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: this.data,
            color: this.color,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    }
  },

  watch: {
    color: {
      handler(n, o) {
        this.color = n
        console.log('--->', this.color)
        this.drawCharts()
      }
    }
  }
}
</script>

<style scoped>
.box {
  width: 100%;
  height: 300px;
}
</style>
